var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-content"},[_c('section',{staticClass:"info-sec"},[_c('div',{staticClass:"max-container"},[_c('div',{staticClass:"reviews"},[_c('statisticsData',{ref:"board"}),_c('reviewDisplay')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }